
export const mapConfig = {
  DETAILED_MARKER_THRESHOLD_COUNT: 300,
  DECKGL_INTERACTIVITY_ZOOM_THRESHOLD: 7.5
};
